import { render, staticRenderFns } from "./QRReaderView.vue?vue&type=template&id=f550351e&scoped=true"
import script from "./QRReaderView.vue?vue&type=script&lang=js"
export * from "./QRReaderView.vue?vue&type=script&lang=js"
import style1 from "./QRReaderView.vue?vue&type=style&index=1&id=f550351e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f550351e",
  null
  
)

export default component.exports